import { call, put, takeEvery, select } from 'redux-saga/effects';
import { constants as ownerDetailsConstants } from '../owner-details/redux';
import { constants } from './redux';
import { actions } from './redux';
import Api from '../../utils/Api';
import {getLocation} from "connected-react-router";
import { matchPath } from 'connected-react-router';
// (`destroy(formName)` from redux-form was used here to wipe the
// form state after a successful create/edit. Under RHF the form's
// state lives inside the dialog component; closing the dialog
// unmounts the FormProvider and discards everything. The
// `setXxxFormMatrixShow(false)` calls below already do that, so
// the destroy() calls were no-ops post-Epic 13f and were removed.)
import { differenceWith, isEqual } from 'lodash';


function* fetchDocumentMatrix() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    yield put(actions.resetState());

    yield put(actions.loadDocumentMatrixRequest());

    const options = { filter: { owner_id: correctPath.params.id } }
    const data = yield call(Api.ownerDocumentMatrix.ownerMatrices, options)

    yield put(actions.loadDocumentMatrixSuccess(data.data))

    yield fetchAllDocuments();

  } catch (e) {
    console.error(e);

    yield put(actions.loadDocumentMatrixError(e));
  }
}

function* fetchCurrentMatrix() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    const currentMatrixId = yield select(s => s.ownerDocumentMatrix.currentDocumentMatrix);
    if (!currentMatrixId) {
      yield put(actions.loadCurrentDocumentMatrixSuccess(null));
      return;
    };
    const options = { filter: { owner_group_id: currentMatrixId } }

    yield put(actions.loadCurrentDocumentMatrixRequest());

    const data = yield call(Api.ownerDocumentMatrix.matrixItems, options)

    yield put(actions.loadCurrentDocumentMatrixSuccess(data.data))


  } catch (e) {
    console.error(e);

    yield put(actions.loadCurrentDocumentMatrixError(e));
  }
}

function* updateItemValue({ payload: { cb, ...payload } }) {
  try {
    yield call(Api.ownerDocumentMatrix.updateItem, payload)

    yield fetchCurrentMatrix();
    if (cb) yield call(cb);
  } catch (e) {
    console.error(e);
  }
}

function* fetchAllDocuments() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    const data = yield call(Api.ownerDocumentMatrix.documents)

    yield put(actions.loadCurrentDocumentMatrixDocumentsSuccess(data.data))
  } catch (e) {
    console.error(e);

    yield put(actions.loadCurrentDocumentMatrixError(e));
  }
}

function* fetchAllRoles() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    const currentMatrixId = yield select(s => s.ownerDocumentMatrix.currentDocumentMatrix);
    // QA bug 3.4 follow-up: `fetchCurrentMatrix` already early-
    // returns on a falsy id but this saga didn't, so a stray
    // null id (e.g. from the exclusive ToggleButtonGroup
    // deselect path) sent `GET .../owner_groups/null/roles` and
    // 404'd. The ToolBar gate is the real fix; this is the
    // belt-and-suspenders so a future caller can't reopen it.
    if (!currentMatrixId) return;
    const data = yield call(Api.ownerDocumentMatrix.roles, currentMatrixId)

    yield put(actions.loadCurrentDocumentMatrixRolesSuccess(data.data))
  } catch (e) {
    console.error(e);

    yield put(actions.loadCurrentDocumentMatrixError(e));
  }
}


function* loadFullFormData({ payload: { id } }) {
  try {
    if (!id) return;
    const {data} = yield call(Api.ownerDocumentMatrix.matrixItemsLoad, id);

    yield put(actions.setFullFormData(data.data))
  } catch (e) {
    console.error(e);

  }
}

function* copyMatrix({ payload: { attributes, cb }}) {
  try {
    const {data} = yield call(Api.ownerDocumentMatrix.copyMatrix, { attributes });

    yield put(actions.copyMatrixSuccess(data.data));

    yield put(actions.setCopyFormMatrixShow(false));
    yield fetchDocumentMatrix();
    yield put(actions.setCurrentDocumentMatrix(data.data.id));
    if (cb) yield call(cb);
  } catch (e) {
    console.error(e);

  }
}

function* fetchRoles() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    const {data: allRoles} = yield call(Api.ranks.index);
    yield put(actions.setCreateFormAllRanks(allRoles));

    const {data: ownerRoles} = yield call(Api.owner.ownerRoles, correctPath.params.id);

    yield put(actions.setCreateFormOwnerRanks(ownerRoles.data));
  } catch (e) {
    console.error(e);

  }

}

function* createMatrix({ payload: attributes }) {
  try {
    const { data } = yield call(Api.ownerDocumentMatrix.createMatrix, { attributes });
    yield put(actions.createMatrixSuccess(data.data));

    yield put(actions.setCreateFormMatrixShow(false));

    yield fetchDocumentMatrix();
    yield put(actions.setCurrentDocumentMatrix(data.data.id));

  } catch (e) {
    console.error(e);
    yield put(actions.createMatrixError(e));
  }
}

function* checkMatrixUniqueness({ payload: { ownerId, name } }) {
  try {
    // Skip validation if name is empty
    if (!name || name.trim() === '') {
      yield put(actions.clearUniquenessValidation());
      return;
    }

    const response = yield call(Api.ownerDocumentMatrix.checkUniqueness, {
      ownerId,
      name: name.trim(),
    });

    yield put(actions.checkUniquenessSuccess(response));
  } catch (e) {
    console.error('Matrix name validation error:', e);
    yield put(actions.checkUniquenessError(e));
  }
}

function* checkMatrix({ payload: { cb, ...query } }) {
  try {
    const { data: { report } } = yield call(Api.users.checkDocumentMatrix, { query });
    yield put(actions.checkReportSuccess(report));

    if (cb) yield call(cb);
  } catch (e) {
    console.error(e);
    yield put(actions.checkReportError(e));
  }
}

function* fetchFreeRoles() {
  try {
    const { pathname } = yield select(getLocation);
    const correctPath = matchPath(pathname, { path: '/owners/:id/document_matrix' })
    if (!correctPath) return;

    const currentMatrixRoles = yield select((s) => s.ownerDocumentMatrix.currentDocumentMatrixRoles);
    const currentMatrixId = yield select(s => s.ownerDocumentMatrix.currentDocumentMatrix);
    if (!currentMatrixId) return;

    const { data: allRoles } = yield call(Api.ownerDocumentMatrix.unusedRoles, currentMatrixId);
    yield put(actions.setEditFormAllRanks(allRoles.data || []));
    
    const { data: ownerRoles } = yield call(Api.owner.ownerRoles, correctPath.params.id);

    const freeOwnerRoles = differenceWith(
      ownerRoles.data,
      currentMatrixRoles,
      isEqual
    );

    yield put(actions.setEditFormOwnerRanks(freeOwnerRoles));
  } catch (e) {
    console.error(e);
  }
}

function* fetchFreeDocuments() {
  try {
    const currentMatrixId = yield select(s => s.ownerDocumentMatrix.currentDocumentMatrix);
    if (!currentMatrixId) return;

    const { data } = yield call(Api.ownerDocumentMatrix.unusedDocuments, currentMatrixId);
    yield put(actions.setEditFormAllDocumentOptions(data.data || []));
  } catch (e) {
    console.error(e);
  }
}

function* editMatrix({ payload: attributes }) {
  try {
    const { data } = yield call(Api.ownerDocumentMatrix.editMatrix, {
      id: attributes.id,
      attributes,
    });

    yield put(actions.editMatrixSuccess(data.data));

    yield put(actions.setEditFormMatrixShow(false));
    yield put(actions.setEditFormMatrixStep(0));

    yield put(actions.setCurrentDocumentMatrix(data.data.id));
    yield fetchCurrentMatrix();
  } catch (e) {
    console.error(e);
    yield put(actions.editMatrixError({ error: e.message }));
  }
}


export default function getFeatureSagas() {
  return [
    takeEvery(
      [ownerDetailsConstants.ADD_LOADED_ITEM],
      fetchDocumentMatrix
    ),
    takeEvery(
      [constants.SET_CURRENT_DOCUMENT_MATRIX],
      fetchCurrentMatrix
    ),
    takeEvery(
      [constants.SET_CURRENT_DOCUMENT_MATRIX],
      fetchAllDocuments
    ),
    takeEvery(
      [constants.SET_CURRENT_DOCUMENT_MATRIX],
      fetchAllRoles
    ),
    takeEvery(
      [constants.CHANGE_ITEM_VALUE],
      updateItemValue
    ),
    takeEvery(
      [constants.SET_SHOW_FULL_FORM],
      loadFullFormData
    ),
    takeEvery(
      [constants.COPY_MATRIX_REQUEST],
      copyMatrix
    ),
    takeEvery(
      [constants.SET_CREATE_FORM_MATRIX],
      fetchRoles
    ),
    takeEvery(
      [constants.CREATE_MATRIX_REQUEST],
      createMatrix
    ),
    takeEvery(
      [constants.CHECK_REPORT_REQUEST],
      checkMatrix,
    ),
    takeEvery(
      [constants.SET_EDIT_FORM_MATRIX],
      fetchFreeRoles
    ),
    takeEvery(
      [constants.SET_EDIT_FORM_MATRIX],
      fetchFreeDocuments
    ),
    takeEvery(
      [constants.EDIT_MATRIX_REQUEST],
      editMatrix
    ),
    takeEvery(
      [constants.CHECK_UNIQUENESS_REQUEST],
      checkMatrixUniqueness
    ),
  ];
}
